export enum LocalizationKeys {
    WelcomeMessage = "WelcomeMessage",
    EnterOtpMessage = "EnterOtpMessage",
    ResendOtp = "ResendOtp",
    SessionProgress = "SessionProgress",
    EstimatedTimeRemaining = "EstimatedTimeRemaining",
    SessionDetails = "SessionDetails",
    Conusmption = "Conusmption",
    ConsumptionWithUnits = "ConsumptionWithUnits",
    ConusmptionOverTime = "ConusmptionOverTime",
    Cost = "Cost",
    CostWithCurrency = "CostWithCurrency",
    CostOverTime = "CostOverTime",
    DurationWithUnits = "DurationWithUnits",
    InactivityWithUnits = "InactivityWithUnits",
    MyChargingSessionAt = "MyChargingSessionAt",
    SessionInProgress = "SessionInProgress",
    SessionCompleted = "SessionCompleted",
    StopTransaction = "StopTransaction",
    PendingInvoice = "PendingInvoice",
    InvoiceReadyTitle = "InvoiceReadyTitle",
    InvoiceReadyBody = "InvoiceReadyBody",
    ReadyToUnplug = "SessionReadyToUnplug",
    TheAmountHasBeenConsumed = "TheAmountHasBeenConsumed",
    Invoice = 'Invoice',
    CumulativePrice = 'CumulativePrice',
    CumulativeConsumption = 'CumulativeConsumption',
    BillingDetailsTitle = 'BillingDetailsTitle',
    PolicyDocument = 'PolicyDocument',
    PolicyChooseDocument = 'PolicyChooseDocument',
    PolicyCheck = 'PolicyCheck',
    PolicyChecking = 'PolicyChecking',
    PolicyWorking = 'PolicyWorking',
    PolicyCheckStatus = 'PolicyCheckStatus',
    PolicyRetrySubmission = 'PolicyRetrySubmission',
    PolicyCancel = 'PolicyCancel',
    PolicyAccepted = 'PolicyAccepted',
    PolicyTerminalConfirmed = 'PolicyTerminalConfirmed',
    PolicyTerminalRejected = 'PolicyTerminalRejected',
    PolicyTerminalUnknown = 'PolicyTerminalUnknown',
    PolicyRetryTerminalConfirmation = 'PolicyRetryTerminalConfirmation',
    PolicyCancelled = 'PolicyCancelled',
    PolicyExpired = 'PolicyExpired',
    PolicyPending = 'PolicyPending',
    PolicyRefreshExpired = 'PolicyRefreshExpired',
    PolicyInvalid = 'PolicyInvalid',
    PolicyInvalidField = 'PolicyInvalidField',
    PolicyCheckFailed = 'PolicyCheckFailed',
    PolicyCheckUnavailable = 'PolicyCheckUnavailable',
    PolicyStorageUnavailable = 'PolicyStorageUnavailable',
    PolicyVerificationExpired = 'PolicyVerificationExpired',
    PolicyVerified = 'PolicyVerified',
    PolicyUnanswered = 'PolicyUnanswered',
    PolicyYes = 'PolicyYes',
    PolicyNo = 'PolicyNo',
    BillingDetailsLoading = 'BillingDetailsLoading',
    BillingDetailsSessionUnavailable = 'BillingDetailsSessionUnavailable',
    BillingDetailsContractUnsupported = 'BillingDetailsContractUnsupported',
    BillingDetailsBody = 'BillingDetailsBody',
    BillingDetailsRecipientType = 'BillingDetailsRecipientType',
    BillingDetailsRecipientBusiness = 'BillingDetailsRecipientBusiness',
    BillingDetailsRecipientIndividual = 'BillingDetailsRecipientIndividual',
    BillingDetailsTaxCountry = 'BillingDetailsTaxCountry',
    BillingDetailsTaxId = 'BillingDetailsTaxId',
    BillingDetailsCui = 'BillingDetailsCui',
    BillingDetailsName = 'BillingDetailsName',
    BillingDetailsCompanyName = 'BillingDetailsCompanyName',
    BillingDetailsAddress = 'BillingDetailsAddress',
    BillingDetailsEmail = 'BillingDetailsEmail',
    BillingDetailsFind = 'BillingDetailsFind',
    BillingDetailsSubmit = 'BillingDetailsSubmit',
    BillingDetailsContinueWithout = 'BillingDetailsContinueWithout',
    BillingDetailsSubmitted = 'BillingDetailsSubmitted',
    BillingDetailsSubmittedNote = 'BillingDetailsSubmittedNote',
    BillingDetailsError = 'BillingDetailsError',
    BillingDetailsLookupError = 'BillingDetailsLookupError',
    BillingDetailsCuiInvalid = 'BillingDetailsCuiInvalid',
    BillingDetailsCuiVerificationRequired = 'BillingDetailsCuiVerificationRequired',
    BillingDetailsCuiFormatInvalid = 'BillingDetailsCuiFormatInvalid',
    BillingDetailsAnafUnavailable = 'BillingDetailsAnafUnavailable',
    BusinessErrorCuiInvalidFormat = 'BusinessErrorCuiInvalidFormat',
    BusinessErrorCuiNotFound = 'BusinessErrorCuiNotFound',
    BusinessErrorCompanyIneligible = 'BusinessErrorCompanyIneligible',
    BusinessErrorAnafUnavailable = 'BusinessErrorAnafUnavailable',
    BusinessErrorAnafTimeout = 'BusinessErrorAnafTimeout',
    BusinessErrorAnafResponseInvalid = 'BusinessErrorAnafResponseInvalid',
    BusinessErrorCompanyStatusUnverified = 'BusinessErrorCompanyStatusUnverified',
    BusinessErrorCompanyDataIncomplete = 'BusinessErrorCompanyDataIncomplete',
    BusinessErrorLookupRateLimited = 'BusinessErrorLookupRateLimited',
    BusinessErrorSessionExpired = 'BusinessErrorSessionExpired',
    BusinessErrorSessionUnauthorized = 'BusinessErrorSessionUnauthorized',
    BusinessErrorSessionForbidden = 'BusinessErrorSessionForbidden',
    BusinessErrorVerificationStale = 'BusinessErrorVerificationStale',
    BusinessErrorRequestInvalid = 'BusinessErrorRequestInvalid',
    BusinessErrorInternal = 'BusinessErrorInternal',
    BusinessVerificationUnknown = 'BusinessVerificationUnknown',
    BillingDetailsCompanyDetails = 'BillingDetailsCompanyDetails',
    BillingDetailsInvoiceIdentifier = 'BillingDetailsInvoiceIdentifier',
    BillingDetailsVerifying = 'BillingDetailsVerifying',
    BusinessActionEditCui = 'BusinessActionEditCui',
    BusinessActionRetry = 'BusinessActionRetry',
    BusinessActionRetryIn = 'BusinessActionRetryIn',
    BusinessActionAttemptsLeft = 'BusinessActionAttemptsLeft',
    BusinessActionSwitchToIndividual = 'BusinessActionSwitchToIndividual',
    BusinessRestartTitle = 'BusinessRestartTitle',
    BusinessRestartBody = 'BusinessRestartBody',
    BillingDetailsAddressSearch = 'BillingDetailsAddressSearch',
    BillingDetailsAddressSearching = 'BillingDetailsAddressSearching',
    BillingDetailsAddressSearchFailed = 'BillingDetailsAddressSearchFailed',
    BillingDetailsAddressSearchIncompatible = 'BillingDetailsAddressSearchIncompatible',
    BillingDetailsAddressNoResults = 'BillingDetailsAddressNoResults',
    BillingDetailsAddressSelect = 'BillingDetailsAddressSelect',
    BillingDetailsCountry = 'BillingDetailsCountry',
    BillingDetailsCounty = 'BillingDetailsCounty',
    BillingDetailsCity = 'BillingDetailsCity',
    BillingDetailsStreet = 'BillingDetailsStreet',
    BillingDetailsNamedIncomplete = 'BillingDetailsNamedIncomplete',
    BillingDetailsCountryRomania = 'BillingDetailsCountryRomania',
    BillingDetailsSelectOption = 'BillingDetailsSelectOption',
    BillingDetailsClearCountry = 'BillingDetailsClearCountry',
}
